import 'date-fns';
import React from 'react';
import moment from 'moment';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import {
  Card,
  CardContent,
  Button,
  TextField,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  IconButton,
  Grid,
} from '@material-ui/core';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import { GetApp, Block } from '@material-ui/icons';

const Fade = require('react-reveal/Fade');

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    rootCard: {
      boxShadow: 'none',
    },
    datePicker: {
      '& .MuiFormControl-root': {
        width: '100%',
        marginTop: 16,
        [theme.breakpoints.up(2550)]: {
          height: 70,
        },
      },
    },
    container: {
      maxHeight: 600,
    },
    downloadButton: {
      padding: 0,
    },
    title: {
      marginBottom: '2rem',
      [theme.breakpoints.up(2550)]: {
        fontSize: '2.8rem',
      },
    },
    [theme.breakpoints.down('sm')]: {
      rootCard: {
        display: 'none',
      },
    },
  })
);

const CariStruk = ({ isId, openModal, onCloseModal }: any) => {
  const classes = useStyles();
  const [openModalStruk, setOpenModalStruk] = React.useState(false);
  const [dataStruk, setDataStruk] = React.useState([]);
  const [formStruk, setFormStruk] = React.useState({
    tglAwal: Date.now(),
    tglAkhir: Date.now(),
    noKartu: '',
  });
  const [noKartuError, setNoKartuError] = React.useState('');

  const { tglAwal, tglAkhir, noKartu } = formStruk;

  const handleFormChange = (value: any, name: string) => {
    setFormStruk({ ...formStruk, [name]: value });
  };

  const handleCloseModalStruk = () => {
    setOpenModalStruk(false);
  };

  const handleCariStruk = async () => {
    if (!noKartu) {
      setNoKartuError('No. Kartu harus diisi');
      return;
    }
    setOpenModalStruk(true);
    try {
      const URL = `${
        process.env.REACT_APP_URL
      }/api/jlp/beranda/struk?tglAwal=${moment(tglAwal).format(
        'YYYY-MM-DD'
      )}&tglAkhir=${moment(tglAkhir).format('YYYY-MM-DD')}&noKartu=${noKartu}`;
      const res = await fetch(URL);
      const resJson = await res.json();
      setDataStruk(resJson.data);
    } catch (err: any) {
      console.log(err.message);
    }
  };

  return (
    <>
      <Grid item xs={12} md={4}>
        <Fade left>
          <Card className={classes.rootCard}>
            <CardContent>
              <Typography
                align='center'
                color='primary'
                variant='h4'
                className={classes.title}
              >
                {isId ? 'Cetak Struk Tol' : 'Print Toll Receipt'}
              </Typography>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <div className={classes.datePicker}>
                  <KeyboardDatePicker
                    id='periode-awal'
                    label='Periode Awal'
                    format='yyyy/MM/dd'
                    value={tglAwal}
                    onChange={(date) => handleFormChange(date, 'tglAwal')}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                  />
                  <KeyboardDatePicker
                    id='sampai-dengan'
                    label='Sampai Dengan'
                    format='yyyy/MM/dd'
                    value={tglAkhir}
                    onChange={(date) => handleFormChange(date, 'tglAkhir')}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                  />
                  <TextField
                    type='number'
                    id='no-kartu'
                    label='No Kartu'
                    value={noKartu}
                    onChange={(e) =>
                      handleFormChange(e.target.value, 'noKartu')
                    }
                    error={noKartuError ? true : false}
                    helperText={noKartuError}
                  />
                </div>
              </MuiPickersUtilsProvider>
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Button
                  variant='contained'
                  color='primary'
                  style={{ marginTop: '2rem' }}
                  onClick={handleCariStruk}
                >
                  {isId ? 'Cetak Struk' : 'Print Receipt'}
                </Button>
              </div>
            </CardContent>
          </Card>
        </Fade>
      </Grid>
      <Dialog
        open={openModalStruk}
        onClose={handleCloseModalStruk}
        maxWidth='md'
        aria-labelledby='dialog-struk'
        aria-describedby='dialog-struk'
      >
        <DialogTitle id='alert-dialog-title'>
          <Typography variant='h6' color='textPrimary'>
            {isId ? 'No. Kartu' : 'Card Number. '} {noKartu}
          </Typography>
          <Typography variant='caption' color='textSecondary'>
            {moment(tglAwal).format('DD MMM YYYY')} -{' '}
            {moment(tglAkhir).format('DD MMM YYYY')}
          </Typography>
        </DialogTitle>
        <DialogContent>
          <TableContainer className={classes.container}>
            <Table stickyHeader aria-label='sticky table'>
              <TableHead>
                <TableRow>
                  {[
                    'No.Resi',
                    'Nama Gerbang',
                    'Gardu',
                    'Saldo',
                    'Tarif',
                    'Waktu',
                    'Download',
                  ].map((row) => (
                    <TableCell align='center' key={row}>
                      {row}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {dataStruk?.map((row: any) => (
                  <TableRow key={row.resi}>
                    <TableCell component='th' scope='row'>
                      {row.resi}
                    </TableCell>
                    <TableCell>{row.nama_gerbang}</TableCell>
                    <TableCell align='center'>{row.gardu}</TableCell>
                    <TableCell>{row.saldo.toLocaleString()}</TableCell>
                    <TableCell>{row.tarif.toLocaleString()}</TableCell>
                    <TableCell align='center'>{row.waktu}</TableCell>
                    <TableCell align='center'>
                      <IconButton
                        color='primary'
                        aria-label='add to shopping cart'
                        className={classes.downloadButton}
                        href={`https://bc01.jtd.co.id${row.link_api}`}
                        target='_blank'
                      >
                        <GetApp />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            {dataStruk.length === 0 && (
              <div
                style={{
                  marginTop: '1rem',
                  textAlign: 'center',
                }}
              >
                <Block />
                <Typography color='textSecondary'>
                  {isId ? 'Tidak ada data Struk' : 'No Receipt Data'}
                </Typography>
              </div>
            )}
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModalStruk} color='primary' autoFocus>
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        onClose={onCloseModal}
        aria-labelledby='simple-dialog'
        open={openModal}
      >
        <DialogContent style={{ paddingBottom: 32 }}>
          <Typography align='center' color='primary' variant='h5' gutterBottom>
            {isId ? 'Cetak Struk Tol' : 'Print Toll Receipt'}
          </Typography>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <div className={classes.datePicker}>
              <KeyboardDatePicker
                id='periode-awal'
                label='Periode Awal'
                format='yyyy/MM/dd'
                value={tglAwal}
                onChange={(date) => handleFormChange(date, 'tglAwal')}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
              />
              <KeyboardDatePicker
                id='sampai-dengan'
                label='Sampai Dengan'
                format='yyyy/MM/dd'
                value={tglAkhir}
                onChange={(date) => handleFormChange(date, 'tglAkhir')}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
              />
              <TextField
                type='number'
                id='no-kartu'
                label='No Kartu'
                value={noKartu}
                onChange={(e) => handleFormChange(e.target.value, 'noKartu')}
                error={noKartuError ? true : false}
                helperText={noKartuError}
              />
            </div>
          </MuiPickersUtilsProvider>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Button
              variant='contained'
              color='primary'
              style={{ marginTop: '2rem' }}
              onClick={handleCariStruk}
            >
              {isId ? 'Cari Struk' : 'Search'}
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default CariStruk;
